enum BeeswaxPacing {
  Lifetime = 'lifetime',
  ASAP = 'none',
}

export default BeeswaxPacing;
